import { mergeAttributes } from "@tiptap/core";
import { Heading, type HeadingOptions } from "@tiptap/extension-heading";
import { type Node } from "@tiptap/pm/model";

export const headingStyles: Record<number, string> = {
	3: "font-weight:500;font-size:24px;margin-bottom:8px;line-height:32px;",
	5: "font-weight:500;font-size:18px;margin-bottom:4px;line-height:28px;",
};

export default Heading.extend({
	addOptions() {
		return {
			...this.parent?.(),
			levels: [3, 5],
		} as HeadingOptions;
	},
	renderHTML(props: { node: Node; HTMLAttributes: Record<string, unknown> }) {
		const { node, HTMLAttributes } = props;
		const level = this.options.levels.includes(node.attrs.level) ? node.attrs.level : this.options.levels[0];

		return [
			`h${level}`,
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
				style: `${headingStyles[level]}`,
			}),
			0,
		];
	},
}).configure({ levels: [3, 5] });
